export default "__VITE_ASSET__9efb286c__"